import { useState } from 'react'
import { Banner, Text } from '@artprov/design-system'
import ModalDdjj from '@/common/components/ddjj/ModalDdjj'
import { useDdjjPendiente } from '@/common/utils/hooks/useDdjjPendiente'
import { BANNER_DDJJ } from './constants/banner-ddjj.js'

// PBI 81147: el link abre el modal de carga de la DDJJ (criterio 1).
// PBI 81906: aviso al médico que todavía no subió la DDJJ en el contrato activo.
// Se usa la forma compuesta del Banner porque la simple sólo acepta link con URL, no onClick.
// El Banner del DS pinta texto y link en 12px (Body-XS / Link-XS); el mockup los pide en 14px,
// así que el contenido va envuelto en Text con body2 y Link-S, que pisan la tipografía heredada.
// `block` evita que el Text quede alineado a la línea base de 12px del contenedor del DS, y
// `p-0` saca el padding de 4px del Link: en el mockup el link no tiene padding y queda a 8px
// (el gap del contenedor) del texto. `items-baseline` alinea texto y link por la línea base:
// body2 tiene line-height 17.5px y Link-S `normal`, así que centrados por caja el link queda
// más abajo que el texto.
export default function BannerDdjjPendiente() {
  const ddjjPendiente = useDdjjPendiente()
  // El useState va antes del return null: con ddjjPendiente en false el componente sigue
  // montado, así que el orden de los hooks no cambia.
  const [modalAbierto, setModalAbierto] = useState(false)
  if (!ddjjPendiente) return null

  const abrirModal = (event) => {
    event.preventDefault() // el Link sigue con href="#"
    setModalAbierto(true)
  }

  return (
    <>
      <Banner.Container feedback="warning" className="min-h-9" classNames={{ content: 'items-baseline' }}>
        <Banner.Text
          text={
            <Text as="span" variant="body2" className="block">
              {BANNER_DDJJ.texto}
            </Text>
          }
        />
        <Banner.Link
          className="p-0"
          text={
            <Text as="span" variant="Link-S" className="block">
              {BANNER_DDJJ.link}
            </Text>
          }
          url="#"
          onClick={abrirModal}
        />
      </Banner.Container>
      <ModalDdjj open={modalAbierto} onClose={() => setModalAbierto(false)} />
    </>
  )
}
